import React from 'react';
import InformacioPuntCard from './InformacioPuntCard';
import InfoPuntPDF from './InfoPuntPDF/InfoPuntPDF';
import { config } from '../../config/Config';

import {
  InformacioGeneral,
  InformacioGeneralContainer,
  InformacioPuntBodyWrapper,
  InformacioPuntFooter,
  LineaInformacio,
  CarouselWrapper,
  Carousel,
  LeftButtons,
  InfoButton,
  InfoPuntSVG,
  FavButton,
  DataAlert
} from './InformacioPuntElement';
import { toLonLat, transform } from 'ol/proj';
import { centerMapTo } from '../Utils/MapUtils';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import EditCard from './EditCard';
import { displayComponents } from '../Utils/VisorsUtils';
import GeoJSON from 'ol/format/GeoJSON';
import { getParentURL } from '../Utils/APIUtils';

export default class InformacioPunt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
      locationHovered: false, //variable de hover activo o inactivo de location
      pdfHovered: false, //variable de pdf activo o inactivo de location
      highLightPos: null // posición de la carta marcada en el mapa
    };
  }
  componentDidMount = () => {
    let selectedCard = this.props.selected.indexOf(true);
    let selected = document.getElementById(`point-info-card-${selectedCard}`);

    if (selected) {
      selected.scrollIntoView({ inline: 'center' });
    }
    if (this.props.apiEnabled && this.props.apiFunctions.clickInfo) {
      const messageCoords = {
        infoName: 'clickInfo',
        data: {
          coords: { ETRS89: this.props.coords, latLon: transform(this.props.coords, config.EPSG, config.EPSG_lonLat) },
          address: `${this.props.carrer}, ${this.props.municipi}`
        }
      };
      window.parent.postMessage(messageCoords, getParentURL());
    }
    if (this.props.apiEnabled && this.props.apiFunctions.clickFeatures) {
      if (this.props.infoPuntInfo?.length > 0) {
        const messageFeatures = {
          infoName: 'clickFeatures',
          data: new GeoJSON().writeFeatures(this.props.infoPuntInfo)
        };
        window.parent.postMessage(messageFeatures, getParentURL());
      }
    }
  };
  componentDidUpdate = (prevProps) => {
    if (prevProps.infoPuntInfo !== this.props.infoPuntInfo) {
      if (this.props.infoPuntInfo?.length === 0) {
        this.props.setFotos({ layer: undefined, fotos: [] });
      }
    }
    if (
      (prevProps.coords !== this.props.coords || prevProps.carrer !== this.props.carrer) &&
      this.props.apiEnabled &&
      this.props.apiFunctions.clickInfo
    ) {
      const message = {
        infoName: 'clickInfo',
        data: {
          coords: { ETRS89: this.props.coords, latLon: transform(this.props.coords, config.EPSG, config.EPSG_lonLat) },
          address: `${this.props.carrer}, ${this.props.municipi}`
        }
      };
      window.parent.postMessage(message, getParentURL());
    }
    if (
      prevProps.infoPuntInfo !== this.props.infoPuntInfo &&
      this.props.infoPuntInfo?.length > 0 &&
      this.props.apiEnabled &&
      this.props.apiFunctions.clickFeatures
    ) {
      const messageFeatures = {
        infoName: 'clickFeatures',
        data: new GeoJSON().writeFeatures(this.props.infoPuntInfo)
      };
      window.parent.postMessage(messageFeatures, getParentURL());
    }
  };
  /**
   * @desc funcion que se encarga de cambiar el estado del boton de ubicacion
   */
  handleLocationBtnEnable = () => {
    this.setState({ locationHovered: true });
  };

  handleLocationBtnDisable = () => {
    this.setState({ locationHovered: false });
  };

  handlePDFBtnDisable = () => {
    this.setState({ pdfHovered: false });
  };

  /**
   * @param {*} pos
   * @desc Función encargada de marcar como seleccionada la tarjeta de la posicion pos
   */
  onClickCard = (pos, fotos) => {
    this.props.selected.fill(false);
    this.props.selected[pos] = true;
    this.setState({ highLightPos: pos });
    this.setState({ selected: this.props.selected }, () => {
      this.forceUpdate();
    });

    this.props.setFotos(fotos);
  };

  removeCard = (idx) => {
    this.props.infoPuntInfo.splice(idx, 1);
    this.forceUpdate();
  };

  favCheck = () => {
    let found = false;
    this.props.favList.forEach((fav) => {
      if (fav.type === 'coords') {
        for (let i = 0; i < fav.fav.length; i++) {
          if (fav.fav[i] !== this.props.coords[i]) {
            return;
          }
        }
        found = true;
      }
    });
    return found;
  };
  toggleDataAlert = () => {
    const Component = () => <p style={{ fontSize: '14px' }}>{getTranslatedKey('dataPrecText')}</p>;
    this.props.toggleAlert(true, <Component />, getTranslatedKey('dataPrec'), false, undefined, true);
  };
  render() {
    return (
      <>
        <InformacioPuntBodyWrapper
          id="info-punt-body"
          altura={window.innerWidth < 465 ? this.props.alturaInfoPunt - 40 + 'px' : this.props.alturaInfoPunt - 45 + 'px'}
          displayInfoPuntBody={this.props.displayInfoPuntBody}
          fontSizeEnabled={this.props.fontSizeEnabled}
          mobile={window.innerWidth < 768}>
          <InformacioGeneralContainer id="info-general" class="info-general">
            {displayComponents.infoPuntInfo && (
              <InformacioGeneral fontSizeEnabled={this.props.fontSizeEnabled}>
                {toLonLat(this.props.coords, config.EPSG)[0].toFixed(6) > 0 &&
                  toLonLat(this.props.coords, config.EPSG)[0].toFixed(6) < 6 &&
                  toLonLat(this.props.coords, config.EPSG)[1].toFixed(6) > 40 &&
                  toLonLat(this.props.coords, config.EPSG)[1].toFixed(6) < 48 && (
                    <LineaInformacio class="linea-info-general">
                      <span style={{ fontWeight: 'bold' }}>ETRS89 - UTM31N:</span> {this.props.coords === null ? '' : this.props.coords[0].toFixed(2)}
                      , {this.props.coords === null ? '' : this.props.coords[1].toFixed(2)}
                    </LineaInformacio>
                  )}
                <LineaInformacio class="linea-info-general" title={''}>
                  <span style={{ fontWeight: 'bold' }}>{getTranslatedKey('geographic') + ': '} </span>
                  {this.props.coords === null ? '' : toLonLat(this.props.coords, config.EPSG)[1].toFixed(6)},{' '}
                  {this.props.coords === null ? '' : toLonLat(this.props.coords, config.EPSG)[0].toFixed(6)}
                </LineaInformacio>
                {this.props.alçada !== '-9999.00' && this.props.alçada !== '-8888.00' && (
                  <LineaInformacio class="linea-info-general">
                    <span style={{ fontWeight: 'bold' }}>{getTranslatedKey('alçada')}:</span> {this.props.alçada} {this.props.alçada && 'm'}
                  </LineaInformacio>
                )}
                {this.props.municipi && this.props.alçada !== '-9999.00' && this.props.alçada !== '-8888.00' && (
                  <>
                    {/* <DataAlert
                      onClick={() => this.toggleDataAlert()}
                      onMouseEnter={() => this.setState({ isAlertHover: true })}
                      onMouseLeave={() => this.setState({ isAlertHover: false })}>
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" width="16" fill="white" viewBox="0 0 512 512">
                        <g>
                          <g>
                            <path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256    C512,114.511,397.504,0,256,0z M282.289,357.621c0,8.088-11.794,16.174-26.284,16.174c-15.164,0-25.946-8.086-25.946-16.174    V229.234c0-9.435,10.783-15.839,25.946-15.839c14.49,0,26.284,6.404,26.284,15.839V357.621z M256.006,182.396    c-15.501,0-27.631-11.457-27.631-24.263c0-12.805,12.131-23.925,27.631-23.925c15.164,0,27.296,11.12,27.296,23.925    C283.302,170.939,271.169,182.396,256.006,182.396z"></path>
                          </g>
                        </g>
                      </svg>
                      {getTranslatedKey('dataPrec')}
                    </DataAlert> */}
                    <LineaInformacio class="linea-info-general">
                      <span style={{ fontWeight: 'bold' }}> {getTranslatedKey('carrer')}:</span> {this.props.carrer}
                    </LineaInformacio>
                    <LineaInformacio class="linea-info-general">
                      <span style={{ fontWeight: 'bold' }}>{getTranslatedKey('municipi')}: </span> {this.props.municipi}
                    </LineaInformacio>
                  </>
                )}
              </InformacioGeneral>
            )}
          </InformacioGeneralContainer>
          {displayComponents.infoPuntInfo && (
            <InformacioPuntFooter id="info-punt-footer " displayInfoPuntBody={this.props.displayInfoPuntBody} displayFooter={window.innerWidth < 465}>
              <LeftButtons id={`point-info-card-footer-left-btns${this.props.id}`}>
                <InfoButton
                  id="go-to-point-btn "
                  title={getTranslatedKey('zoomPoint')}
                  onClick={() => centerMapTo(this.props.coords, this.props.map, false, true, this.props.alturaInfoPunt, true)}
                  onMouseEnter={() => this.setState({ locationHovered: true })}
                  onMouseLeave={() => this.setState({ locationHovered: false })}>
                  <InfoPuntSVG
                    fontSizeEnabled={this.props.fontSizeEnabled}
                    space="preserve"
                    transform="scale(0.9)"
                    paddingBottom="2px"
                    viewBox="0 0 32 32"
                    fill={window.innerWidth > 768 ? (this.state.locationHovered ? '#febf00' : 'white') : 'white'}>
                    <path d="M28.5259,3.1494a1,1,0,0,0-.9732-.0439L20,6.8818,12.4473,3.1055a1.0008,1.0008,0,0,0-.8946,0l-8,4A1,1,0,0,0,3,8V28a1,1,0,0,0,1.4473.8945L12,25.1182l3.5527,1.7763a1,1,0,0,0,.8946-1.789L13,23.3818V8a1,1,0,0,0-2,0V23.3818l-6,3V8.6182l7-3.5,7,3.5V14a1,1,0,0,0,2,0V8.6182l6-3V18a1,1,0,0,0,2,0V4A1,1,0,0,0,28.5259,3.1494Z" />
                    <path d="M26.167,24.7529a5.015,5.015,0,1,0-1.4141,1.4141l2.54,2.54a1,1,0,0,0,1.414-1.414ZM19,22a3,3,0,1,1,3,3A3.0033,3.0033,0,0,1,19,22Z" />
                  </InfoPuntSVG>
                </InfoButton>
                {displayComponents.infoPuntPDF && (
                  <InfoPuntPDF
                    favFeatureInfo={this.props.favFeatureInfo}
                    layersSelectedOnClick={this.props.layersSelectedOnClick}
                    infoPuntInfo={this.props.infoPuntInfo}
                    alçada={this.props.alçada}
                    carrer={this.props.carrer}
                    municipi={this.props.municipi}
                    coords={this.props.coords}
                  />
                )}
                {displayComponents.preferits && (
                  <FavButton title={getTranslatedKey('favCoord')} onClick={() => this.props.addToFav(this.props.coords, 'coords')}>
                    {this.favCheck() ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="favFill"
                        fill="#febf00"
                        enable-background="new 0 0 511.992 511.992"
                        viewBox="0 0 511.992 511.992"
                        width="22">
                        <path d="m510.616 196.062c-3.944-12.141-15.728-20.486-32.329-22.897l-131.649-19.132-58.875-119.294c-7.425-15.043-19.003-23.671-31.767-23.671s-24.342 8.628-31.766 23.671l-58.873 119.293-131.651 19.132c-16.602 2.411-28.385 10.757-32.33 22.896-3.944 12.14.684 25.817 12.695 37.526l95.263 92.856-22.489 131.121c-2.957 17.247 2.065 27.561 6.8 33.176 5.538 6.568 13.617 10.186 22.749 10.186 6.904 0 14.257-2.024 21.85-6.018l117.752-61.907 117.752 61.905c7.595 3.993 14.947 6.019 21.852 6.019h.002c9.133 0 17.212-3.617 22.75-10.186 4.734-5.614 9.757-15.929 6.799-33.177l-22.492-131.118 95.262-92.855c12.013-11.709 16.64-25.387 12.695-37.526z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" id="favStandard" fill="white" width="22" viewBox="0 0 32 32">
                        <path d="m7.998 30.544c-.415 0-.827-.129-1.176-.382-.589-.428-.899-1.143-.809-1.866l.98-7.839-5.399-5.766c-.498-.532-.668-1.293-.442-1.986.225-.692.81-1.208 1.524-1.345l7.759-1.49 3.813-6.918c.353-.638 1.023-1.035 1.752-1.035s1.399.396 1.751 1.034 3.814 6.918 3.814 6.918l7.758 1.49c.715.137 1.3.653 1.524 1.345.226.693.056 1.454-.441 1.986l-5.401 5.766.98 7.839c.091.723-.22 1.438-.809 1.866-.591.429-1.366.501-2.025.192l-7.152-3.354-7.152 3.354c-.271.127-.561.189-.85.189zm7.999-26.631-3.812 6.923c-.288.521-.788.885-1.373.998l-7.76 1.49 5.4 5.766c.408.436.6 1.024.525 1.616l-.98 7.838 7.152-3.354c.542-.253 1.16-.252 1.698 0l7.153 3.355-.98-7.839c-.074-.591.117-1.18.525-1.615l5.4-5.766-7.759-1.49c-.586-.113-1.086-.477-1.374-.998l-3.817-6.923z" />
                      </svg>
                    )}
                  </FavButton>
                )}
              </LeftButtons>
            </InformacioPuntFooter>
          )}
          <Carousel mobile={window.innerWidth < 768} amplada={window.innerWidth < 568 ? 450 : 450 * this.props.nCards} nCards={this.props.nCards}>
            <CarouselWrapper
              id="carousel-wrapper"
              amplada={window.innerWidth < 568 ? 450 : 450 * this.props.nCards}
              mobile={window.innerWidth < 768}
              innerWidth={window.innerWidth}>
              {this.props.infoPuntInfo && (!this.props.isEditing?.isEditing || this.props.isEditing?.type === 'deleteGeom')
                ? this.props.infoPuntInfo.map((feature, index) => {
                    let layerName = feature.id_?.split('.')[0];
                    let isRaster = false;
                    if (feature.raster) {
                      isRaster = true;
                      layerName = feature.layerName;
                    }
                    if (layerName !== undefined && layerName !== null) {
                      let nomCapa, nomPunt, layerSelected, layer, featureName;
                      if (this.props.layersSelectedOnClick.length > 0 && !this.props.favFeatureInfo) {
                        for (let i = 0; i < this.props.layersSelectedOnClick.length; ++i) {
                          layerSelected = this.props.layersSelectedOnClick[i];
                          if (layerSelected.Name === layerName || layerSelected.getName() === layerName || isRaster) {
                            nomCapa = feature.layerName || layerSelected.Name || layerSelected.getTitle();
                            nomPunt = layerSelected.Tooltip || layerSelected.getExtension().ToolTip;
                            layer = layerSelected;
                            featureName = nomPunt;
                            // eslint-disable-next-line no-loop-func
                            Object.entries(feature.values_).forEach(([key, value]) => {
                              if (key === nomPunt) {
                                featureName = value;
                              }
                            });
                          }
                        }
                      } else {
                        let favLayer = this.props.favFeatureInfo.layer;
                        nomCapa = favLayer.Name || favLayer.getTitle();
                        nomPunt = favLayer.Tooltip || favLayer.getExtension().ToolTip;
                        layer = favLayer;
                      }
                      return (
                        <InformacioPuntCard
                          setEditing={this.props.setEditing}
                          isEditing={this.props.isEditing}
                          toggleAlert={this.props.toggleAlert}
                          isRaster={isRaster}
                          favList={this.props.favList}
                          addToFav={this.props.addToFav}
                          prevFotos={this.props.prevFotos}
                          tableInfoToggle={this.props.tableInfoToggle}
                          setFotos={this.props.setFotos}
                          infoPuntInfo={this.props.infoPuntInfo}
                          toggleGaleria={this.props.toggleGaleria}
                          removeCard={this.removeCard}
                          id={index}
                          featureName={featureName}
                          nomCapa={nomCapa}
                          nomPunt={nomPunt}
                          layer={layer}
                          altura={this.props.alturaInfoPunt}
                          coords={this.props.coords}
                          map={this.props.map}
                          bbox={!isRaster && feature.getGeometry().getExtent()}
                          info={feature.values_}
                          feature={feature}
                          featureOverlay={this.props.featureOverlay}
                          onClickCard={this.onClickCard}
                          selected={this.props.selected[index]}
                          fontSizeEnabled={this.props.fontSizeEnabled}></InformacioPuntCard>
                      );
                    }
                  })
                : this.props.isEditing?.isEditing &&
                  this.props.showEditCard && (
                    <EditCard
                      editCardProps={this.props.editCardProps}
                      toggleAlert={this.props.toggleAlert}
                      isEditing={this.props.isEditing}
                      setEditing={this.props.setEditing}
                      editVector={this.props.editVector}
                      editFeature={this.props.editFeature}
                      altura={this.props.alturaInfoPunt}
                      layer={this.props.isEditing.layer}
                      type={this.props.isEditing.type}
                    />
                  )}
            </CarouselWrapper>
          </Carousel>
        </InformacioPuntBodyWrapper>
        {displayComponents.infoPuntInfo && (
          <InformacioPuntFooter
            id="info-punt-footer"
            displayInfoPuntBody={this.props.displayInfoPuntBody}
            displayFooter={window.innerWidth >= 465}
            isMin={this.props.alturaInfoPunt === 35}>
            <LeftButtons id={`point-info-card-footer-left-btns ${this.props.id}`}>
              <InfoButton
                id="go-to-point-btn"
                title={getTranslatedKey('zoomPoint')}
                className="go-to-point-btn"
                onClick={() => centerMapTo(this.props.coords, this.props.map, false, true, this.props.alturaInfoPunt, true)}
                onMouseEnter={() => this.setState({ locationHovered: true })}
                onMouseLeave={() => this.setState({ locationHovered: false })}>
                <InfoPuntSVG
                  fontSizeEnabled={this.props.fontSizeEnabled}
                  space="preserve"
                  transform="scale(0.9)"
                  paddingBottom="2px"
                  viewBox="0 0 32 32"
                  fill={window.innerWidth > 768 ? (this.state.locationHovered ? '#febf00' : 'white') : 'white'}>
                  <path d="M28.5259,3.1494a1,1,0,0,0-.9732-.0439L20,6.8818,12.4473,3.1055a1.0008,1.0008,0,0,0-.8946,0l-8,4A1,1,0,0,0,3,8V28a1,1,0,0,0,1.4473.8945L12,25.1182l3.5527,1.7763a1,1,0,0,0,.8946-1.789L13,23.3818V8a1,1,0,0,0-2,0V23.3818l-6,3V8.6182l7-3.5,7,3.5V14a1,1,0,0,0,2,0V8.6182l6-3V18a1,1,0,0,0,2,0V4A1,1,0,0,0,28.5259,3.1494Z" />
                  <path d="M26.167,24.7529a5.015,5.015,0,1,0-1.4141,1.4141l2.54,2.54a1,1,0,0,0,1.414-1.414ZM19,22a3,3,0,1,1,3,3A3.0033,3.0033,0,0,1,19,22Z" />
                </InfoPuntSVG>
              </InfoButton>
              {displayComponents.infoPuntPDF && (
                <InfoPuntPDF
                  favFeatureInfo={this.props.favFeatureInfo}
                  layersSelectedOnClick={this.props.layersSelectedOnClick}
                  infoPuntInfo={this.props.infoPuntInfo}
                  alçada={this.props.alçada}
                  carrer={this.props.carrer}
                  municipi={this.props.municipi}
                  coords={this.props.coords}
                />
              )}
              {displayComponents.preferits && (
                <FavButton
                  onMouseEnter={() => this.setState({ favHovered: true })}
                  onMouseLeave={() => this.setState({ favHovered: false })}
                  title={getTranslatedKey('favCoord')}
                  onClick={() => this.props.addToFav(this.props.coords, 'coords')}>
                  {this.favCheck() ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="favFill"
                      fill="#febf00"
                      enable-background="new 0 0 511.992 511.992"
                      viewBox="0 0 511.992 511.992"
                      width="22">
                      <path d="m510.616 196.062c-3.944-12.141-15.728-20.486-32.329-22.897l-131.649-19.132-58.875-119.294c-7.425-15.043-19.003-23.671-31.767-23.671s-24.342 8.628-31.766 23.671l-58.873 119.293-131.651 19.132c-16.602 2.411-28.385 10.757-32.33 22.896-3.944 12.14.684 25.817 12.695 37.526l95.263 92.856-22.489 131.121c-2.957 17.247 2.065 27.561 6.8 33.176 5.538 6.568 13.617 10.186 22.749 10.186 6.904 0 14.257-2.024 21.85-6.018l117.752-61.907 117.752 61.905c7.595 3.993 14.947 6.019 21.852 6.019h.002c9.133 0 17.212-3.617 22.75-10.186 4.734-5.614 9.757-15.929 6.799-33.177l-22.492-131.118 95.262-92.855c12.013-11.709 16.64-25.387 12.695-37.526z" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="favStandard"
                      fill={window.innerWidth > 768 ? (this.state.favHovered ? '#febf00' : 'white') : 'white'}
                      width="22"
                      viewBox="0 0 32 32">
                      <path d="m7.998 30.544c-.415 0-.827-.129-1.176-.382-.589-.428-.899-1.143-.809-1.866l.98-7.839-5.399-5.766c-.498-.532-.668-1.293-.442-1.986.225-.692.81-1.208 1.524-1.345l7.759-1.49 3.813-6.918c.353-.638 1.023-1.035 1.752-1.035s1.399.396 1.751 1.034 3.814 6.918 3.814 6.918l7.758 1.49c.715.137 1.3.653 1.524 1.345.226.693.056 1.454-.441 1.986l-5.401 5.766.98 7.839c.091.723-.22 1.438-.809 1.866-.591.429-1.366.501-2.025.192l-7.152-3.354-7.152 3.354c-.271.127-.561.189-.85.189zm7.999-26.631-3.812 6.923c-.288.521-.788.885-1.373.998l-7.76 1.49 5.4 5.766c.408.436.6 1.024.525 1.616l-.98 7.838 7.152-3.354c.542-.253 1.16-.252 1.698 0l7.153 3.355-.98-7.839c-.074-.591.117-1.18.525-1.615l5.4-5.766-7.759-1.49c-.586-.113-1.086-.477-1.374-.998l-3.817-6.923z" />
                    </svg>
                  )}
                </FavButton>
              )}
            </LeftButtons>
          </InformacioPuntFooter>
        )}
      </>
    );
  }
}
